import axios from "axios";

export default function updateGroupBranches(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .put(`/account/api/v1/branch-group/add-branch-into-group`, {
        branch_group_uuid: parameters.branch_group_uuid,
        selected: parameters.selected,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
